import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import Keycloak from 'keycloak-js';
import { environment } from 'src/environments/environment';

// Migration v20 : KeycloakAuthGuard (classe abstraite) est déprécié
// on passe à un guard fonctionnel CanActivateFn, meme logique de vérification des roles
// hasResourceRole remplace isUserInRole de l'ancien KeycloakService
export const authGuard: CanActivateFn = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): Promise<boolean> => {
  const keycloak = inject(Keycloak);

  if (!keycloak.authenticated) {
    await keycloak.login({
      redirectUri: window.location.origin + state.url
    });
    return false;
  }

  const requiredRoles: string[] = route.data['roles'] ?? [];
  if (requiredRoles.length === 0) {
    return true;
  }

  const clientId = environment.keycloak.clientId;
  return requiredRoles.some(role => keycloak.hasResourceRole(role, clientId));
};
